<script setup lang="ts">
const { product } = useProduct()
const { promotionDetails, isVisible, availability, elementRef } = useCampaignDeal(product)

const campaignColor = computed(() => promotionDetails.value?.campaignColor ?? undefined)
const { borderStyle, headerStyle } = useCampaignTheme(campaignColor)
</script>

<template>
    <div
        v-if="isVisible"
        ref="elementRef"
        class="border border-neutral-focus"
        :style="borderStyle"
        data-cy="product-detail-campaign-deal"
    >
        <div
            class="flex flex-wrap items-baseline justify-between gap-x-2 gap-y-1 bg-neutral-focus px-4 py-3 text-neutral-content"
            :style="headerStyle"
        >
            <span class="font-fjalla-one text-lg lg:text-xl uppercase">
                {{ promotionDetails?.campaignTitle || $t('campaign.detail.title') }}
            </span>

            <MiscCountdown
                v-if="promotionDetails?.validUntil"
                class="shrink-0"
                :target-date="promotionDetails.validUntil"
                value-class="text-base lg:text-xl"
                unit-class="text-xxs font-normal"
            />
        </div>

        <div class="flex flex-col gap-1 px-4 py-3 md:px-5 md:py-4">
            <div>
                <span class="font-semibold">{{ promotionDetails?.discount }}%</span>
                {{ $t('campaign.detail.extra') }}
            </div>

            <div class="text-xxs text-base-content-subtle">
                {{ $t('campaign.detail.autoDeducted') }}
            </div>

            <CampaignAvailabilityBar
                v-if="availability"
                class="mt-3 text-xxs"
                :remaining="availability.remaining"
                :max="availability.max"
                label-key="campaign.detail.remaining"
            />
        </div>
    </div>
</template>
